"use client";

import { ComponentWithLoadingFallback } from "@faire/retailer-visitor-shared/components/GhostLoading/ComponentWithLoadingFallback";
import { GhostText } from "@faire/retailer-visitor-shared/components/GhostLoading/GhostTypography";
import { IBrandSubtitleProps } from "@faire/retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/__internal__/SearchPageHeaderAndResults/__internal__/SearchPageHeader/__internal__/SearchPageBrandSearch/BrandSearch/BrandSearchSubtitle";
import { DEPRECATED_backwardsCompatibleValues } from "@faire/web/common/localization";
import { formatMoney, RoundingStrategy } from "@faire/web/common/money";
import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React from "react";

export const BrandMinimum: React.FC<{
  isLoading: boolean;
  brand: IBrandSubtitleProps | undefined;
}> = ({ isLoading, brand }) => {
  return (
    <ComponentWithLoadingFallback
      fallback={<GhostText />}
      isLoading={isLoading}
    >
      {brand?.minimum_order_amount ? (
        <Typography variant="paragraphSansRegular">
          <StrictLocalMsg
            id="3P/RZ3"
            defaultMessage="{brandMinimum} min"
            description={{
              text: "X min would indicate the minimum cost of ordering from a brand",
            }}
            values={DEPRECATED_backwardsCompatibleValues({
              brandMinimum: formatMoney({
                money: brand.minimum_order_amount,
                roundingStrategy: RoundingStrategy.DROP_CENTS_ROUND_UP,
              }),
            })}
          />
        </Typography>
      ) : null}
    </ComponentWithLoadingFallback>
  );
};
